import React from "react";
import withShipment from "../../../withShipment";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {Tabs, Tab, Table, TableRow, TableCell, IconButton, Tooltip, TextField} from "@material-ui/core";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FileUpload from "../../global/FileUpload";
import {
    FTL_PAGES,
    FTL_SIGNATURES_TABLE_HEADERS,
    ADD_SIGNATURE,
    REMOVE_DOCUMENT,
    BACK, SAVE, FULL_TRUCKLOAD_SETTINGS,
} from "../constants";
import {getByteArray} from "../../global/constants";
import SaveIcon from "@material-ui/icons/Save";
import {
    clearSignatureRelatedResponseMessage,
    listFullTruckloadSignatures,
    saveFullTruckloadSignatures
} from "../../../redux/actions/fullTruckload";
import {
    fullTruckloadSignaturesSelector,
    signatureResponseMessageSelector
} from "../../../redux/selectors/fullTruckload";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import {ERROR, SUCCESS} from "../../shipments/constants";
import Radio from '@material-ui/core/Radio';

class FullTruckloadSignatures extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signatures: [],
            settingsChanged: false,
            deletedAttachments: [],
            feedbackBarOpen: false,
            errorMessage:"",
            errorFeedbackBarOpen: false,
        };
    }

    componentDidMount() {
        this.props.listFullTruckloadSignatures()
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.signatures !== this.props.signatures) {
            this.setState({
                signatures: this.props.signatures,
            })
        }
        if (prevProps.responseMessage !== this.props.responseMessage && this.props.responseMessage!=="") {
            this.setState({
                feedbackBarOpen: true
            })
        }
    }

    addSignature = () => {
        let tempSignatureList = this.state.signatures;
        tempSignatureList.push({ name: "", file: null });
        this.setState({
            signatures: tempSignatureList
        });
    };

    deleteSignature = (index) => {
        let newSignatures = this.state.signatures
        let newDeletedAttachments = this.state.deletedAttachments
        newDeletedAttachments.push(newSignatures[index])
        newSignatures.splice(index, 1)
        this.setState({
            signatures: newSignatures,
            deletedAttachments: newDeletedAttachments,
            deletingRowIndex: -1,
            settingsChanged: true
        })
    };

    handleChanges = (e, index) => {
        let tempSignatures = this.state.signatures
        tempSignatures[index][e.target.name] = e.target.value
        this.setState({
            signatures: tempSignatures
        });
    }

    handleSetDefaultSignature = (selectedIndex) => {
        const updatedSignatures = this.state.signatures.map((sig, idx) => ({
            ...sig,
            isDefault: idx === selectedIndex
        }));
        this.setState({ signatures: updatedSignatures });
    };

    handleGeneralFileAdd = (file, index) => {
        let newSignatures = this.state.signatures
        // replace new file with previous file
        if (newSignatures[index].file?.displayName && !newSignatures[index].file?.byteArray) {
            let deletedAttachment = JSON.parse(JSON.stringify(newSignatures[index]));
            this.setState({
                deletedAttachments: [...this.state.deletedAttachments, deletedAttachment]
            });
        }
        newSignatures[index].file = this.getFormattedGeneralFileObject(file)
        this.setState({
            signatures: newSignatures,
            settingsChanged: true
        });
    }

    getFormattedGeneralFileObject = (file) => {
        return { localURL: URL.createObjectURL(file), displayName: file.name, byteArray: getByteArray(file), type: file.type }

    }

    handleGeneralFileDelete = (file, fileIndex, index) => {
        let newSignatures = this.state.signatures
        // make a deep copy
        let deletedAttachment = JSON.parse(JSON.stringify(newSignatures[index]));
        newSignatures[index].file = null
        this.setState({
            deletedAttachments: [...this.state.deletedAttachments, deletedAttachment],
            signatures: newSignatures,
            settingsChanged: true,
        })
    }

    saveSignatures = () => {
        let allowSave = true
        this.state.signatures.forEach(signature => {
            if (signature.file == null || !signature?.file?.displayName?.includes(".png")) {
                allowSave = false
            }
        })
        if (allowSave) {
            let newSignatures = {
                signatures: this.state.signatures,
                deletedAttachments: this.state.deletedAttachments.filter(attachment => attachment.file?.displayName)
            }
            this.props.saveFullTruckloadSignatures(newSignatures, () => this.setState({settingsChanged: false}))
        }
        else {
            this.setState({
                errorMessage: "Please ensure each signature has a related PNG attachment",
                errorFeedbackBarOpen: true,
            })
        }
    }

    closeFeedbackBar = () => {
        this.setState({
            feedbackBarOpen: false
        })
        this.props.clearSignatureRelatedResponseMessage()
    }

    closeErrorFeedbackBar = () => {
        this.setState({
            errorFeedbackBarOpen: false,
            errorMessage: "",
        })
    }

    render() {
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    severity={SUCCESS}
                    message={this.props.responseMessage}
                    handleClose={this.closeFeedbackBar}
                />
                <FeedbackBar
                    open={this.state.errorFeedbackBarOpen}
                    severity={ERROR}
                    message={this.state.errorMessage}
                    handleClose={this.closeErrorFeedbackBar}
                />
                <TopToolbar
                    pageName={FULL_TRUCKLOAD_SETTINGS}
                    menuItems={[
                        { title: BACK, icon: <KeyboardBackspaceIcon />, onClick: () => { this.props.setCurrentPage(FTL_PAGES.TABLE); } },
                        { title: SAVE, icon: <SaveIcon/>, onClick: () => {this.saveSignatures()}},
                    ]}
                />

                <Tabs
                    value={this.props.selectedTab}
                    onChange={(event, value) => this.props.handleTabChange(value)}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label={FTL_PAGES.SETUP} />
                    <Tab label={FTL_PAGES.CUSTOMS_BROKERS} />
                    <Tab label={FTL_PAGES.SIGNATURES} />
                    <Tab label= {FTL_PAGES.NOA_PORTS}/>
                </Tabs>

                <div style={{ margin: "25px" }}>
                    <Table>
                        <TableRow>
                            {FTL_SIGNATURES_TABLE_HEADERS.map((headCell) => (
                                <TableCell key={headCell.id} style={{ textAlign: headCell.textAlign, fontWeight: "bold", width: headCell.width }}>
                                    {headCell.label}
                                </TableCell>
                            ))}
                        </TableRow>
                        {this.state.signatures.map((signature, index) => (
                            <TableRow key={index}>
                                <TableCell style={{width:"10%"}}>
                                    <Tooltip title={REMOVE_DOCUMENT}>
                                        <IconButton onClick={() => this.deleteSignature(index)}>
                                            <RemoveCircleIcon fontSize="small" color="error" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell style={{width:"25%"}}>
                                    <TextField
                                        style={{width:"100%"}}
                                        className='text-field'
                                        variant="outlined"
                                        name="name"
                                        value={signature.name}
                                        onChange={(e) => this.handleChanges(e, index)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                    />
                                </TableCell>
                                <TableCell style={{width:"25%"}}>
                                    <TextField
                                        style={{width:"100%"}}
                                        className='text-field'
                                        variant="outlined"
                                        name="position"
                                        value={signature.position}
                                        onChange={(e) => this.handleChanges(e, index)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                    />
                                </TableCell>
                                <TableCell style={{width:"30%"}}>
                                    <FileUpload
                                        accept=".png,image/png"
                                        handleFileAdd={(file) => this.handleGeneralFileAdd(file, index)}
                                        handleFileDelete={(file, fileIndex) => this.handleGeneralFileDelete(file, fileIndex, index)}
                                        files={signature.file ? [signature.file] : []}
                                        fetchFilePreview={(file) => {this.props.previewFullTruckloadFile({ path: file.path, displayName: file.displayName, index: index, type: "Signature"})}}
                                        singleFileUpload={true}
                                        isFTL={true}
                                    />
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    <Radio
                                        checked={signature?.isDefault === true}
                                        onChange={() => this.handleSetDefaultSignature(index)}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell>
                                <Tooltip title={ADD_SIGNATURE}>
                                    <IconButton onClick={this.addSignature}>
                                        <AddCircleIcon fontSize="small" color="secondary" />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                        </TableRow>
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    signatures: fullTruckloadSignaturesSelector(state),
    responseMessage: signatureResponseMessageSelector(state),
});

const actionCreators = {
    clearSignatureRelatedResponseMessage,
    saveFullTruckloadSignatures,
    listFullTruckloadSignatures,
};

export default withShipment({
    mapStateToProps,
    actionCreators,
}, FullTruckloadSignatures);
